// import Cryptr from 'cryptr';
import errorHandler from "@/services/handler/erroHandler";
import axiosInstance from "@/services/manager/manager.service";



export const pharmacyService = {
    get
};
/*let crypt = new Cryptr(process.env.VUE_APP_REMEMBER_CRYPT);*/

async function get(){
    try {
        let rets = await axiosInstance.get(`/pharmacies`);
        if (rets) {
            return rets.data;
        }
        return 400;
    } catch (error) {
        return errorHandler(error);
    }
}

